import { Type } from "@sinclair/typebox";
import { httpRouteContracts } from "./http.js";
import { AccessMessageBodySchema } from "./schemas/access.js";
import { ActionMessageBodySchema } from "./schemas/action.js";
// 登记表同时供浏览器使用，只加载冻结 schema；Node 摘要计算留在服务端入口。
import { ToolsMessageBodySchema } from "./schemas/mcp.js";
import { GuideMessageBodySchema } from "./schemas/guide.js";
import { ModelMessageBodySchema } from "./schemas/model.js";
import { ProviderSearchMessageBodySchema } from "./schemas/provider-search.js";
import { RuntimeMessageBodySchema } from "./schemas/runtime.js";
import { TaskMessageBodySchema } from "./schemas/task.js";
export const ProtocolIds = {
    task: "rnavoyager-task/7",
    action: "rnavoyager-action/1",
    model: "rnavoyager-model/7",
    tools: "rnavoyager-tools/1",
    access: "rnavoyager-access/5",
    runtime: "rnavoyager-runtime/3",
    guide: "rnavoyager-guide/4",
    providerSearch: "rnavoyager-provider-search/1",
};
export const RuntimeArtifactStream = Object.freeze({
    lengthEncoding: "uint32be",
    lengthPrefixBytes: 4,
    maximumFrameBytes: 4 * 1024 * 1024,
    endFrameLength: 0,
    requireTerminalFrame: true,
});
const protocolCompatibility = Object.freeze({
    [ProtocolIds.task]: { window: 1, removal: null },
    [ProtocolIds.action]: { window: 1, removal: null },
    [ProtocolIds.model]: { window: 1, removal: null },
    [ProtocolIds.tools]: { window: 1, removal: null },
    [ProtocolIds.access]: { window: 1, removal: null },
    [ProtocolIds.runtime]: { window: 1, removal: null },
    [ProtocolIds.guide]: { window: 1, removal: null },
    [ProtocolIds.providerSearch]: { window: 1, removal: null },
});
function entry(number, id, bodySchema) {
    return Object.freeze({
        number,
        id,
        bodySchema,
        httpRoutes: httpRoutesFor(number),
        compatibility: protocolCompatibility[id],
        wireSchema: Type.Object({
            protocol: Type.Literal(id),
            body: bodySchema,
        }, {
            $id: id,
            additionalProperties: false,
            ...(id === ProtocolIds.runtime
                ? { "x-rnavoyager-artifact-stream": RuntimeArtifactStream }
                : {}),
        }),
    });
}
export const protocolRegistry = Object.freeze([
    entry(1, ProtocolIds.task, TaskMessageBodySchema),
    entry(2, ProtocolIds.action, ActionMessageBodySchema),
    entry(3, ProtocolIds.model, ModelMessageBodySchema),
    entry(4, ProtocolIds.tools, ToolsMessageBodySchema),
    entry(5, ProtocolIds.access, AccessMessageBodySchema),
    entry(6, ProtocolIds.runtime, RuntimeMessageBodySchema),
    entry(7, ProtocolIds.guide, GuideMessageBodySchema),
    entry(8, ProtocolIds.providerSearch, ProviderSearchMessageBodySchema),
]);
const registeredHttpRouteCount = protocolRegistry.reduce((total, protocol) => total + Object.keys(protocol.httpRoutes).length, 0);
if (registeredHttpRouteCount !== Object.keys(httpRouteContracts).length) {
    throw new TypeError("HTTP route contract 未被八项协议登记表一一覆盖");
}
export function protocolById(id) {
    return protocolRegistry.find((candidate) => candidate.id === id);
}
function httpRoutesFor(number) {
    return Object.freeze(Object.fromEntries(Object.entries(httpRouteContracts).filter(([, route]) => route.protocolNumber === number)));
}
//# sourceMappingURL=protocol-registry.js.map